import { createAction } from "@reduxjs/toolkit";

export const requestCampaign = createAction("campaign/requestCampaign");
export const selectCampaignMobile = createAction("campaign/selectCampaignMobile");
